/* eslint-disable max-lines */
import { act } from 'api';
import {
  SET_ACT_PROPERTY,
  ACT_GET_ACTS,
  ACT_GET_ACT,
  ACT_CMS,
  ACT_SAVE_DATA,
  CANCEL_ACT,
  VALIDATE_DOCUMENT,
  GET_DOCUMENTS,
  UI_UPDATE_FROM_PARTNER,
  END_SIGN,
  ACT_ERROR,
  GET_REQUIRED_DOCUMENTATION,
  ACT_GET_TRANSFER_ACTS,
  ACT_GET_TRANSFER_ACT,
  ACT_SAVE_DATA_TRANSFER,
  CANCEL_ACT_TRANSFER,
  GET_DISCREPANCIES_FLEX_CHECK
} from 'store/actions/act';
import {
  lsRemoveActs,
  lsSetActs,
  lsSetAct,
  lsSetTransferAct,
  lsSetTransferActs,
  lsRemoveTransferActs,
  lsRemoveTransferAct
} from 'helpers/store';
import { setCurrentDateTimeIfNull } from 'helpers/date';
import { ensureTyreProperties } from 'helpers/object';
import { userProfile } from 'helpers/user';

export default {
  [SET_ACT_PROPERTY]: ({ commit }, { field, value }) => commit(SET_ACT_PROPERTY, { field, value }),

  [ACT_GET_ACTS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      lsRemoveActs();
      const identityData = {
        dateCheck: state.dateCheck,
        idStoragePark: state.identityData.idStoragePark,
        idCliente: state.identityData.idCliente,
        plate: state.identityData.plate
      };
      commit(SET_ACT_PROPERTY, {
        field: 'identityData.dateCheck',
        value: state.dateCheck
      });
      act.login(identityData).then(
        resp => {
          const actsData = resp.data;
          lsSetActs(actsData);
          commit(SET_ACT_PROPERTY, {
            field: 'acts',
            value: actsData
          });
          commit(SET_ACT_PROPERTY, {
            field: 'errorIdentity',
            value: null
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [ACT_GET_ACT]: ({ commit }, plate) =>
    new Promise((resolve, reject) => {
      const { email, id, partnerid } = userProfile();
      const filters = {
        plate,
        mailUser: email ?? null,
        idUser: id ?? null,
        idPartner: partnerid ?? null
      };
      act.getAct(filters).then(
        resp => {
          const actData = ensureTyreProperties({
            data: setCurrentDateTimeIfNull({
              data: resp.data,
              prop: 'variable.date'
            })
          });
          lsSetAct(actData);
          commit(SET_ACT_PROPERTY, {
            field: 'act',
            value: actData
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [ACT_GET_TRANSFER_ACTS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      lsRemoveTransferActs();
      const filters = {
        dateCheck: state.checkTransferFilters.dateCheck,
        idStoragePark: state.checkTransferFilters.idStoragePark,
        idProvider: state.checkTransferFilters.idProvider,
        idTransport: state.checkTransferFilters.idTransport,
        plate: state.checkTransferFilters.plate
      };
      act.getTransferActs(filters).then(
        resp => {
          const actsData = resp.data;
          lsSetTransferActs(actsData);
          commit(SET_ACT_PROPERTY, {
            field: 'transferActs',
            value: actsData
          });
          commit(SET_ACT_PROPERTY, {
            field: 'errorIdentity',
            value: null
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [ACT_GET_TRANSFER_ACT]: ({ commit }, plate) =>
    new Promise((resolve, reject) => {
      const { email, id, partnerid } = userProfile();
      const filters = {
        plate,
        mailUser: email ?? null,
        idUser: id ?? null,
        idPartner: partnerid ?? null
      };
      lsRemoveTransferAct();
      act.getTransferAct(filters).then(
        resp => {
          const actData = ensureTyreProperties({
            data: setCurrentDateTimeIfNull({
              data: resp.data,
              prop: 'variable.date'
            })
          });
          lsSetTransferAct(actData);
          commit(SET_ACT_PROPERTY, {
            field: 'transferAct',
            value: actData
          });
          resolve();
        },
        err => {
          reject(err.response.data.error);
        }
      );
    }),

  [ACT_CMS]: ({ commit }, { partnerId, patternId }) =>
    new Promise((resolve, reject) => {
      act.cms(partnerId, patternId).then(
        resp => {
          commit(SET_ACT_PROPERTY, {
            field: 'componentsCMS',
            value: [resp.data]
          });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [ACT_SAVE_DATA]: (params, { data }) =>
    new Promise((resolve, reject) => {
      act.saveAct(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [ACT_SAVE_DATA_TRANSFER]: (params, { data }) =>
    new Promise((resolve, reject) => {
      act.saveActTransfer(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [CANCEL_ACT]: (params, { transactionId, comment }) =>
    new Promise((resolve, reject) => {
      act.cancelAct(transactionId, comment).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [CANCEL_ACT_TRANSFER]: (params, { transactionId, comment }) =>
    new Promise((resolve, reject) => {
      act.cancelActTransfer(transactionId, comment).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      act.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_DOCUMENTS]: (params, data) =>
    new Promise((resolve, reject) => {
      act.getDocuments(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_REQUIRED_DOCUMENTATION]: ({ commit }, { partnerId, patternId }) =>
    new Promise((resolve, reject) => {
      act.catalogByPartnerIdAndStep(partnerId, patternId).then(
        resp => {
          const data = resp.data;
          commit(UI_UPDATE_FROM_PARTNER, { patternId, data });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [END_SIGN]: ({ commit }, payload) =>
    new Promise((resolve, reject) => {
      act.endSign(payload).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          commit(ACT_ERROR, err);
          reject();
        }
      );
    }),

  [GET_DISCREPANCIES_FLEX_CHECK]: (_, { data }) =>
    new Promise((resolve, reject) => {
      act.getDiscrepanciesFlexCheck(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data.error);
        }
      );
    })
};
